// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
  emergentLink: "home-emergent-link",
};

export const PROMO = {
  root: "home-promo",
  cta: "home-promo-cta",
  card: "home-promo-card",
};
